import { Injectable } from '@angular/core';
import { UnsafeAction } from 'app/actions/UnsafeAction';
import { Address } from 'app/models';

/* tslint:disable */
@Injectable()
export class TicketAddressActions {

	static SET_ADDRESSES = "[TICKETADDRESS] SET_ADDRESSES";
	static UPDATE_ADDRESSES = "[TICKETADDRESS] UPDATE_ADDRESSES"

	public setTicketAddresses(ticketAddresses: Record<string, Address>): UnsafeAction {
		return {
			type: TicketAddressActions.SET_ADDRESSES,
			payload: ticketAddresses
		};
	};

	public updateTicketAddresses(ticketAddresses: Record<string, Address>): UnsafeAction {
		return {
			type: TicketAddressActions.UPDATE_ADDRESSES,
			payload: ticketAddresses
		};
	};
};



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/ticket-address/reducer/ticket-address.actions.ts